<template>
	<div
		class="ms-grid-viewer"
		:class="{ selectedTextMode: selectedTextMode, 'h-auto': maxHeight }"
		v-if="columnx.length"
	>
		<div
			class="ms-content--header"
			ref="header"
			:class="{
				'hide-scroll': scrollVisiable && !greyTitle,
				'hide-scroll-grey': scrollVisiable && greyTitle,
			}"
		>
			<div>
				<table class="ms-table">
					<thead class="ms-thead">
						<tr class="ms-tr">
							<th
								v-if="multiple"
								class="ms-th multiple-cell"
								:class="{ 'grey-title': greyTitle }"
							>
								<ms-checkbox
									:value="isCheckedMultiple"
									@click="changeCheckedMultiple"
									class="justify-center"
									checkOnly
								/>
							</th>
							<th
								class="ms-th serial-title"
								v-if="serial"
								:class="{ 'grey-title': greyTitle }"
							>
								STT
							</th>
							<ms-th
								ref="th"
								class="ms-th"
								v-for="(col, colIndex) in columnx"
								:key="col.dataField"
								:col="col"
								:resizeCol="resizeCol"
								@resizeOn="resizeActive"
								:class="{ 'grey-title': greyTitle }"
								@resizeOff="resizeClose"
								@sort="sort"
							></ms-th>
							<th
								class="ms-th widget-title"
								v-if="widgetOptions"
								:class="[
									`text-${widgetOptions.align ? widgetOptions.align : 'right'}`,
									{ 'grey-title': greyTitle },
								]"
								:style="[
									{ 'min-width': `${widgetOptions.width}px` },
									columnx.length > 0
										? { width: `${widgetOptions.width}px` }
										: null,
								]"
							>
								<span>{{ widgetOptions.title }}</span>
							</th>
						</tr>
					</thead>
				</table>
			</div>
		</div>
		<div
			class="ms-content--table"
			@scroll="onScroll"
			:style="[gridViewStyle]"
			ref="content"
			v-if="!dataEmpty"
		>
			<table class="ms-table" v-if="groupField">
				<tbody class="ms-tbody">
					<ms-group-tr
						v-for="(dataRow, indexRow) in datax"
						:isSelected="isSelected(dataRow)"
						:key="dataRow['__vKeyValue']"
						:columns="columnx"
						:index="indexRow"
						:dataRow="dataRow"
						:widgetOptions="widgetOptions"
						:serial="serial"
						:pageSize="pageSize"
						:currentPage="currentPage"
						:multiple="multiple"
						v-on="listeners"
						:groupField="groupField"
						:loadChildrenData="loadChildrenData"
					></ms-group-tr>
				</tbody>
			</table>
			<table class="ms-table" v-else>
				<transition
					name="trans-content-table"
					mode="out-in"
					v-on:before-enter="beforeRenderContent"
				>
					<tbody
						class="ms-tbody"
						v-if="shimmerLoaded !== false"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="(dataRow, indexRow) in datax"
								:isSelected="isSelected(dataRow)"
								:key="dataRow['__vKeyValue']"
								:columns="columnx"
								:index="indexRow"
								:dataRow="dataRow"
								:widgetOptions="widgetOptions"
								:serial="serial"
								:pageSize="pageSize"
								:currentPage="currentPage"
								:multiple="multiple"
								:rowSelected="rowSelected.data"
								v-on="listeners"
								:class="[
									{ 'row-selected': dataRow == rowSelected.data },
									{ 'action-pointer': checkListenerDbClick },
									typeof customClassRow == 'function'
										? customClassRow(dataRow)
										: customClassRow,
								]"
							></ms-tr>
						</template>
					</tbody>
					<tbody
						class="ms-tbody"
						v-if="shimmerLoaded === false"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="n in 5"
								:key="n"
								:index="n"
								:columns="columnx"
								:widgetOptions="widgetOptions"
								:serial="serial"
								:multiple="multiple"
								isChart
							></ms-tr>
						</template>
					</tbody>
				</transition>
			</table>
		</div>
		<div v-else-if="hasFilterEmpty" class="h-full flex-box align-center">
			<img
				:src="require(`@/assets/images/pages/No_data.svg`)"
				class="nodata-img"
			/>
			<div class="mt-4">{{ $t('i18nCommon.NoFilterData') }}</div>
		</div>
		<div v-else class="text-center h-full flex-box justify-center">
			<div>{{ $t('i18nCommon.noData') }}</div>
		</div>

		<ms-pagination
			v-if="pagination"
			:pageSize="pageSize"
			:dataRender="datax.length"
			:hidePageRange="hidePageRange"
			:pagingTemplate="pagingTemplate"
			:pageIndex="currentPage"
			:pageTotal="pageTotal"
			@loadData="listenersLoadData"
		></ms-pagination>
	</div>
	<div class="loading" v-else>
		<div class="effect-1 effects"></div>
	</div>
</template>
<script>
import msTr from './msTr';
import msGroupTr from './msGroupTr';
import msTh from './msTh';
import msPagination from './msPagination';
import commonFunc from '@/common/commonFunction.js';
import msDynamicScroll from '@/components/msvirtualscroller/MsDynamicScroller.vue';
import msDynamicScrollerItem from '@/components/msvirtualscroller/MsDynamicScrollerItem.vue';
import { MSEventName } from '@/common/eventName';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	name: 'msGridViewer',
	components: {
		msTr,
		msGroupTr,
		msTh,
		msPagination,
		msDynamicScroll,
		msDynamicScrollerItem,
	},
	props: {
		greyTitle: {
			default: false,
			type: Boolean,
		},
		//Value thực hiện lưu giá trị các cột được chọn
		value: {},
		//Data dữ liệu grid từ ngoài truyền vào
		data: {
			type: Array,
			return: () => [],
		},
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 * @params template:Sử dụng 1 file khác ở ngoài truyền vào để render
		 */
		columns: {
			type: Array,
			return: () => [],
		},
		/**
		 * Cấu hình cho cột chức năng là 1 đối tượng gồm có
		 * title: tên tiêu đề cột chức năng
		 * components:'components import vào'
		 * width:Độ rộng của cột
		 */
		widgetOptions: {},
		//Set độ rộng cho grid
		maxHeight: {
			default: null,
			type: [Number, String],
		},
		//Cấu hình có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
		queryMode: {
			default: 'remote',
			type: String,
		},
		//Số bản ghi trên mới trang trường hợp phân trang local
		pageSize: {
			default: 20,
			type: Number,
		},
		//Cột cho phép tích chọn nhiều dòng
		multiple: {
			default: false,
			type: Boolean,
		},
		indexFlexRight: {
			default: 1,
			type: Number,
		},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		//Hiện thị cột số thứ tự
		serial: {
			default: false,
			type: Boolean,
		},
		//Cho phép di chuyển độ rộng của cột hay không
		resizeCol: {
			default: true,
			type: Boolean,
		},
		//Trường để kiểm tra sort dưới client hay trên sever
		//Local/Serve
		remoteSort: {
			default: 'remote',
			type: String,
		},
		//Data là dạng Master/Detail
		isMasterDetail: {
			default: false,
			type: Boolean,
		},
		detailField: {
			default: 'Details',
			type: String,
		},
		hasFilterEmpty: {
			default: false,
			type: Boolean,
		},
		shimmerLoaded: {
			default: null,
		},
		customClassRow: {
			default: null,
		},
		groupField: {
			default: null,
			type: String,
		},
		loadChildrenData: {
			default: null,
		},
		pagingTemplate: {},
		/**
		 * Ẩn range số bản ghi (1-N of Total) và nút First/Last, chỉ giữ nút Previous/Next
		 */
		hidePageRange: {
			default: false,
			type: Boolean,
		},
	},
	/**
	 * Hàm khởi tạo grid khởi tạo column vào data
	 * Created by LTDAT 16.06.2020
	 */
	created() {
		const me = this;
		me.initColumns();
		me.initData();
		document.addEventListener('click', me.clickOutGrid);
		window.addEventListener('resize', me.updateSize);
	},
	/**
	 *
	 */
	watch: {
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				this.checkHasScroll();
				if (me.datax != me.data) {
					me.initData(newVal);
				}
			},
		},
	},
	mounted() {},
	computed: {
		//Kiểm tra có lắng nghe xử lý sự kiện dblick hay không? nếu có thì đổi icon thành pointer
		checkListenerDbClick() {
			if (this._events.dblclick && this._events.dblclick.length > 0) {
				return true;
			}
			return false;
		},
		//Hàm kiểm tra xem có scroll hay không?
		scrollVisiable() {
			if (this.hasScroll) {
				return true;
			}
			return false;
		},
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		//Created by LTDAT(18.06.2020)
		listeners() {
			const me = this;
			return {
				click: (dataRow, event) => {
					// if (me.rowSelected && me.rowSelected.data != dataRow) {
					// 	let indexRow = me.datax.findIndex(item => item == dataRow);
					// 	me.rowSelected = {
					// 		data: dataRow,
					// 		index: indexRow
					// 	};
					event.target.focus();
					// }
					me.$emit('click', dataRow);
				},
				focus: (dataRow, event) => {
					if (me.rowSelected && me.rowSelected.data != dataRow) {
						let indexRow = me.datax.findIndex((item) => item == dataRow);
						me.rowSelected = {
							data: dataRow,
							index: indexRow,
						};
						event.target.focus();
					}
					me.$emit('click', dataRow);
				},
				dblclick: (dataRow, event) => {
					me.$emit('dblclick', dataRow, event);
				},
				keydown: (dataRow, event) => {
					me.row_keydown(dataRow, event);
					me.$emit('keydown', dataRow, event);
				},
				widgetEvent: (data, event) => {
					me.$emit('widgetEvent', data, event);
				},
				clickMultiple: (dataRow) => {
					me.clickMultiple(dataRow);
				},
			};
		},
		/**
		 * Kiểm tra xem tất cả dữ liệu có đang được check hay không
		 * created by LTDAT 25.06.2020
		 */
		isCheckedMultiple() {
			if (this.value) {
				if (this.datax.length != 0) {
					return (
						this.value.length >= this.datax.length &&
						this.datax.every((item, index) => {
							return this.value.includes(item);
						})
					);
				} else {
					return false;
				}
			}
		},
		// //Set style cho grid độ rộng,...
		gridViewStyle() {
			if (this.maxHeight) {
				return { 'max-height': this.maxHeight };
			} else {
				return null;
			}
		},
		dataEmpty() {
			// return false;
			if (this.datax && this.datax.length > 0) {
				return false;
			} else return true;
		},
	},
	//Nếu dữ liệu thay đổi thì check scroll
	updated() {
		const me = this;
		me.updateSize();
	},
	methods: {
		/**
		 * Hàm Cập nhật lại giao diện khi có scroll hay khi độ rộng của data dài hơn độ rộng mặc định của cột
		 * Created by LTDAT
		 */
		updateSize() {
			const me = this;
			me.$nextTick(() => {
				me.checkHasScroll();
				if (me.$refs.tr && me.$refs.tr.length > 0) {
					me.columnx.forEach((col, index) => {
						let changeMinWidth = false;
						me.$refs.tr.forEach((item) => {
							if (
								item.$refs[`text-${col.dataField}`] &&
								item.$refs[`text-${col.dataField}`].length > 0
							) {
								let textSpan =
									item.$refs[`text-${col.dataField}`][0].offsetWidth;
								if (col._width < textSpan + 20) {
									changeMinWidth = true;
									if (
										me.$refs.th[index].$el.offsetWidth !=
										item.$refs[`td-${col.dataField}`][0].offsetWidth
									) {
										me.$set(
											col,
											'_minWidth',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
										me.$set(
											col,
											'_width',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
									}
								}
							}
						});
						if (changeMinWidth == false) {
							me.$set(col, '_minWidth', col._width);
						}
					});
				}
			});
		},
		/**
		 * Hàm trước thực hiện transition bắt đầu render.
		 * Created by LTDAT
		 */
		beforeRenderContent() {
			const me = this;
			me.updateSize();
		},
		/**
		 * Thực hiện khi ấn vào ngoài grid loại bỏ row đang chọn
		 * Created by LTDAT
		 *  */

		clickOutGrid(event) {
			const me = this;
			if (event.target.closest('.ms-grid-viewer') != me.$el) {
				me.rowSelected = {};
			}
		},
		/**
		 * Hàm thực hiện việc sort trên grid
		 * @params col cột được thực hiện sắp sếp
		 * @params mode gồm null,DESC,ASC
		 * created by LTDAT
		 */

		sort(col, mode) {
			const me = this;
			if (me.datax && me.datax.length > 0) {
				if (me.remoteSort == 'remote') {
					let payload = {
						Skip: (me.currentPage - 1) * me.pageSize,
						Take: me.pageSize,
					};
					if (mode != me.$ms.enum.SortStatus.none) {
						payload.Sort = `${col.dataField} ${
							mode == me.$ms.enum.SortStatus.desc ? 'DESC' : 'ASC'
						}`;
					}
					me.listenersLoadData(payload);
				} else {
					let data = [...me.internalDataSource];
					function compare(a, b) {
						if (a[col.dataField] < b[col.dataField])
							return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
						if (a[col.dataField] > b[col.dataField])
							return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
						return 0;
					}
					if (mode != me.$ms.enum.SortStatus.none) {
						me.datax = data.sort(compare);
					} else {
						me.datax = data;
					}
				}
			}
		},
		//Kiểm tra xem grid có scroll hay không để chỉnh lại size của grid cho đúng
		//Created by LTDAT (29.07.2020)
		checkHasScroll() {
			this.$nextTick(() => {
				if (this.$refs.content) {
					if (
						this.$refs.content.getBoundingClientRect().height + 2 <
						this.$refs.content.scrollHeight
					) {
						this.hasScroll = true;
					} else {
						this.hasScroll = false;
					}
				}
			});
		},
		/**
		 * Hàm lắng nghe sự kiến thay đổi trang nếu thay đổi thì emit sự kiện load data mới ra ngoài
		 * @param payload dữ liệu thông tin trang gửi ra ngoài
		 *  */
		//Created by LTDAT(27.07.2020)
		listenersLoadData(payload) {
			const me = this;
			if (me.pagination) {
				me.currentPage = payload.Skip / payload.Take + 1;
			}
			if (me.$refs.content) {
				me.$refs.content.scrollTop = 0;
			}
			me.$emit('loadData', payload);
		},
		//Hàm sự kiện khi ấn nút chọn tất cả trên tiêu đề
		//Created by LTDAT
		changeCheckedMultiple() {
			const me = this;
			if (me.isCheckedMultiple) {
				me.$emit('input', []);
			} else {
				me.$emit('input', me.datax);
			}
		},
		/**
		 * Sự kiện scroll trên grid
		 * Thay đổi lại tọa độ scroll trên header
		 * Created by LTDAT(25.06.2020)
		 */
		onScroll(e) {
			const me = this;
			me.$refs.header.scrollLeft = e.target.scrollLeft;
			EventBusGlobal.$emit(GlobalEventName.scrollEvent, e);
			me.$emit('scroll', e);
		},

		/**
		 * Kiểm tra xem cột được check hay không ?
		 * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
		 * @param dataRow dữ liệu của dòng được check
		 * Created by LTDAT 24.06.2020
		 *  */
		isSelected(dataRow) {
			const me = this;
			if (me.value && me.value.length > 0) {
				return me.value.includes(dataRow);
			}
			return false;
		},
		/**
		 * Hàm xử lý sự kiện khi click vào ô check multiple
		 * @param dataRow dữ liệu của dòng được chọn
		 * Created by LTDAT (30.05.2020)
		 */
		clickMultiple(dataRow) {
			const me = this;
			let VModel = [...me.value];
			if (VModel.includes(dataRow)) {
				VModel.remove(dataRow);
			} else {
				VModel.push(dataRow);
			}
			me.$emit('input', VModel);
		},

		//Lấy dữ liệu của 1 trang khi phân trang local
		//Created by LTDAT(18.06.2020)
		getItemPagination() {
			let me = this,
				pageSize = me.pageSize ? me.pageSize : 20,
				min = Math.ceil((me.currentPage - 1) * pageSize),
				max = min + pageSize;
			let dataPagination = me.internalDataSource.filter((item, index) => {
				return index >= min && index < max;
			});
			return dataPagination;
		},
		//Xử lý sự kiện resize col trên grid
		//created by LTDAT(29.05.2020)
		resizeActive() {
			//Không cho phép bôi đen text
			this.selectedTextMode = true;
			if (this.$refs.th) {
				let listTh = this.$refs.th;
				if (listTh && listTh.length > 0) {
					listTh.forEach((item) => {
						if (item == listTh[listTh.length - this.indexFlexRight]) {
							item.updateColWidth(true);
						} else {
							item.updateColWidth(false);
						}
					});
				}
			}
		},
		//Đóng sự kiện resize cột trên grid
		//created by LTDAT(29.05.2020)

		resizeClose() {
			//Cho phép bôi đên text
			this.selectedTextMode = false;
		},
		/**
		 * Set giá trị default cho cấu hình cột
		 * Created by LTDAT(17.07.2020)
		 */
		setDefaultFieldColumn(columns) {
			//Nếu không cấu hình field hiện thị thì mặc định là true
			const me = this;
			columns.forEach((item) => {
				if (item.visiable != false) {
					item.visiable = true;
				}
				if (item.formatType == me.$ms.enum.FormatType.Number) {
					item.align = 'right';
				} else if (
					item.formatType == me.$ms.enum.FormatType.Date ||
					item.formatType == me.$ms.enum.FormatType.DateTime
				) {
					item.align = 'center';
				}
				me.$set(item, '_width', item.width);
			});
		},
		/** Lấy ra các column có thuộc tính visiable = true
		 * Created by LTDAT 17.07.2020
		 * */
		getVisiableColumn(columns) {
			return columns.filter((item) => {
				return item.visiable == true;
			});
		},
		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			me.columnx = [];
			me.$nextTick(() => {
				me.columnx = columns ? columns : me.columns;
				me.setDefaultFieldColumn(me.columnx);
				me.columnx = me.getVisiableColumn(me.columnx);
				if (!me.columnx) {
					me.columnx = [];
				}
				let hasFlex = me.columnx.some((item) => {
					return item.autoResize;
				});
				if (
					hasFlex == false &&
					me.columnx[me.columnx.length - me.indexFlexRight]
				) {
					// me.resizeActive();
					me.$set(
						me.columnx[me.columnx.length - me.indexFlexRight],
						'autoResize',
						true
					);
				} else if (hasFlex == false && me.columnx.length == 1) {
					me.$set(me.columnx[0], 'autoResize', true);
				}
				me.$nextTick(() => {
					let header = me.$refs.header;
					{
						if (header) {
							header.style.minHeight =
								header.firstElementChild.offsetHeight + 1 + 'px';
						}
					}
				});
			});
		},
		//Xóa 1 phần tử trong data grid
		removeItem(item) {
			const me = this;
			me.datax = _.remove(me.datax, (e) => {
				return e !== item;
			});
		},
		//Gán giá trị để render data có thể truyền từ ngoài vào
		initData(data = this.data) {
			const me = this;
			me.internalDataSource = null;
			if (data) {
				me.internalDataSource = [...data];
			}
			//Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
			if (me.queryMode == 'local' && me.pagination) {
				commonFunc.genVKeyValue(me.internalDataSource);
				me.datax = me.getItemPagination();
			} else {
				//Lấy dữ liệu từ server
				//Tạm gán = props data sau gán = gì khác tính sau
				me.datax = [...me.internalDataSource];
				commonFunc.genVKeyValue(me.datax);
			}
			if (me.isMasterDetail) {
				me.datax = me.$ms.commonFunc.getBodyData(
					me.datax,
					true,
					1,
					me.detailField
				);
			}
			me.$nextTick(() => {
				this.checkHasScroll();
			});
		},
		//Lấy dữ liệu của dòng được chọn
		//Created by LTDAT(16.06.2020)
		getRowSelected() {
			const me = this;
			return me.rowSelected;
		},
		//Xử lý sự kiện ấn phím trên row
		//Created by LTDAT(15.06.2020)
		row_keydown(dataRow, e) {
			const me = this;
			let currentIndex = me.rowSelected.index;
			switch (e.which) {
				case 40: //down
					if (currentIndex < me.datax.length - 1 && !e.altKey) {
						currentIndex++;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
				case 38: //up
					if (currentIndex > 0 && !e.altKey) {
						currentIndex--;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
			}
		},
	},
	data() {
		return {
			//Data trong grid dùng để render
			datax: null,
			//Columns trong grid dùng để render
			columnx: [],
			//Mode cho phép copy dữ liệu hay không thực hiện với các event kéo thả cột,độ rộng,...
			selectedTextMode: false,
			//Trang hiện tại
			currentPage: 1,

			//Dòng đang được chọn
			rowSelected: {},
			//Kiểm tra data đã được load hay chưa
			dataLoaded: false,
			hasScroll: false,
		};
	},
	beforeDestroy() {
		const me = this;
		document.removeEventListener('click', me.clickOutGrid);
		window.removeEventListener('resize', me.updateSize);
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
</style>
